export default "__VITE_ASSET__978dbf29__"